import { Activity, Flame, ThermometerSnowflake, ThermometerSun } from "lucide-react";

export const TIER_META = {
    hot: { label: "Hot", tone: "border-rose-400/40 text-rose-300 bg-rose-400/10", Icon: Flame },
    warm: { label: "Warm", tone: "border-orange-400/40 text-orange-300 bg-orange-400/10", Icon: ThermometerSun },
    watch: { label: "Watch", tone: "border-amber-400/40 text-amber-300 bg-amber-400/10", Icon: Activity },
    cold: { label: "Cold", tone: "border-slate-400/30 text-slate-300 bg-slate-400/5", Icon: ThermometerSnowflake },
};

export const FUNNEL_META = {
    site_selection: { label: "Site selection", tone: "text-emerald-300" },
    early_recruiting: { label: "Early recruiting", tone: "text-teal-300" },
    mature: { label: "Mature recruiting", tone: "text-sky-300" },
    closed: { label: "Closed", tone: "text-indigo-300" },
    stopped: { label: "Stopped", tone: "text-rose-300" },
    unverified_stale: { label: "Unverified", tone: "text-amber-300" },
    gate_closed: { label: "Gate closed", tone: "text-slate-300" },
    window_open: { label: "Window open", tone: "text-emerald-300" },
    no_phase_data: { label: "No phase data", tone: "text-slate-400" },
};

export const CONFIDENCE_TONE = {
    high: "border-emerald-400/40 text-emerald-300 bg-emerald-400/10",
    medium: "border-sky-400/40 text-sky-300 bg-sky-400/10",
    low: "border-amber-400/40 text-amber-300 bg-amber-400/10",
    news_only: "border-slate-400/30 text-slate-400 bg-slate-400/5",
    none: "border-slate-400/30 text-slate-400 bg-slate-400/5",
    "match-llm-1.4": "border-violet-400/40 text-violet-300 bg-violet-400/10",
};

export function fmtDate(iso) {
    if (!iso) return "—";
    const s = String(iso).slice(0, 10);
    return s;
}

/** 44588 → "$45K", 2184500 → "$2.18M", 303000 → "$303K". */
export function fmtMoney(n, currency = "USD") {
    if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
    const v = Number(n);
    const sym = currency === "EUR" ? "€" : currency === "GBP" ? "£" : "$";
    const abs = Math.abs(v);
    if (abs >= 1e9) return `${sym}${(v / 1e9).toFixed(2)}B`;
    if (abs >= 1e6) return `${sym}${(v / 1e6).toFixed(2)}M`;
    if (abs >= 1e3) return `${sym}${Math.round(v / 1e3)}K`;
    return `${sym}${Math.round(v)}`;
}

export const VALUE_REASON_LABEL = {
    no_scored_phase: "No scored phase",
    extension_or_rollover: "Extension / rollover — no new sites",
    enrollment_closed: "Enrollment closed",
    stopped: "Stopped",
};

export const SOURCE_TYPE_META = {
    news: { label: "News", short: "News", tone: "border-slate-500/40 text-slate-300 bg-slate-500/10" },
    press_release: { label: "Press release", short: "PR", tone: "border-sky-400/40 text-sky-300 bg-sky-400/10" },
    sec_filing: { label: "SEC filing", short: "SEC", tone: "border-emerald-400/40 text-emerald-300 bg-emerald-400/10", verified: true },
    sec_10k: { label: "10-K / annual report", short: "10-K", tone: "border-teal-400/40 text-teal-300 bg-teal-400/10", verified: true },
    pipeline: { label: "Sponsor pipeline page", short: "Pipeline", tone: "border-amber-400/40 text-amber-300 bg-amber-400/10" },
    ctgov: { label: "ClinicalTrials.gov", short: "CT.gov", tone: "border-cyan-400/40 text-cyan-300 bg-cyan-400/10", verified: true },
    ctis: { label: "CTIS (EU register)", short: "CTIS", tone: "border-blue-400/40 text-blue-300 bg-blue-400/10", verified: true },
};

const CTIS_ID = /^\d{4}-5\d{5}-\d{2}-\d{2}$/;
export const isCtisId = (id) => CTIS_ID.test(String(id || ""));
export const registryUrl = (id) => (isCtisId(id)
    ? `https://euclinicaltrials.eu/search-for-clinical-trials/?lang=en&EUCT=${id}`
    : `https://clinicaltrials.gov/study/${id}`);
